import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import cflService from '../service/cfl-service'
import Swal from 'sweetalert2';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Button, Container, Row, Col } from 'react-bootstrap';


const FormCursoDos = ({initialValues, onSubmit, isEditing = false}) => {

    const [loading, setLoading] = useState(false);
    const [familias, setFamilias] = useState([]);
    const [instructores, setInstructores] = useState([]);
    const [tipos, setTipos] = useState([]);
    const navigate=useNavigate();
    
    useEffect(() => {
  cflService.getFamilias()
    .then(res => {
      console.log("Familias recibidas:", res.data); 
      setFamilias(res.data.data);
    })
    .catch(err => {
      console.error("Error al traer familias", err);
    });
  cflService.getInstructores()
    .then(res => setInstructores(res.data.data))
    .catch(err => {
      console.error("Error al traer familias", err);
    });
  //cflService.getSedes().then(res => setSedes(res.data));
  cflService.getTipos().then(res => setTipos(res.data.data));
}, []);


    const asterico = <span id="i4" className="rAXpye" aria-label="Pregunta obligatoria">*</span>

    // Aca voy a crear mi funcion para enviar los datos a la bdd
    
    const handleSubmit = (values) => {
        console.log("SE DISPARÓ EL SUBMIT");
        setLoading(true)

    const fechaPublicacion = (() => {
        const date = new Date();
        date.setMonth(date.getMonth() - 3); // Resta 3 meses
        return date.toISOString().split("T")[0];
    })();

    const anioActual = new Date().getFullYear();

    function normalizeDate(dateStr) {
        if (!dateStr) return ""; 
        const fixed = dateStr.replace(/\//g, '-');
        const d = new Date(fixed);
        if (isNaN(d.getTime())) return ""; 
        return d.toISOString().split('T')[0];
    }

    const data = {
        idCurso: initialValues.idCurso ?? 0,
        nombre: values.nombre,
        nroCurso: parseInt(values.nroCurso),
        horasCatedra: parseInt(values.horasCatedra),
        horasReloj: parseInt(values.horasReloj),
        codigo: values.codigo,
        cupo: values.cupo,
        fechaPublicacion: fechaPublicacion,
        anio: anioActual,
        fechaFinalizacion: normalizeDate(values.fechaFinalizacion),
        fechaInicio: normalizeDate(values.fechaInicio),
        disponibilidad: parseInt(values.cupo),
        visible: 0,
        familiaIdFamilia: parseInt(values.familiaIdFamilia),
        instructorIdInstructor: parseInt(values.instructorIdInstructor),
        sedeIdSede: 1,
        tipo_id_tipo: parseInt(values.tipo_id_tipo),
    };

    console.log("DATA A ENVIAR:", data);

    cflService.crearCurso(data)
        .then((resp) => {
            setLoading(false)
            if (resp.data.success) {
                Swal.fire({
                    title:'Éxito',
                    text:`Se registró con éxito`,
                    icon:"success",
                    showConfirmButton:false,
                    showCloseButton:true
                }).then(() => {navigate("/cursos");window.location.reload()})
            } else {
                Swal.fire({
                    title:'Cuidado!',
                    text:`El curso ya existe`,
                    icon:"warning",
                    showConfirmButton:false,
                    showCloseButton:true
                })
            }
        })
        .catch((error) => {
            setLoading(false)
            Swal.fire({
                title:'Error',
                text:`Revise su conexión o intente más tarde`,
                icon:"error",
                showConfirmButton:false,
                showCloseButton:true
            })
            console.error(error);
        });
}


    // funcion para las validaciones del formulario, Utilizando la libreria YUP

    const validationSchema = yup.object().shape({
    nombre: yup.string().required('Por favor, complete este campo.'),
    nroCurso: yup
        .number()
        .typeError('Debe ser un número')
        .required('Este campo es obligatorio'),
    horasCatedra: yup
        .number()
        .typeError('Debe ser un número')
        .required('Este campo es obligatorio'),
    horasReloj: yup
        .number()
        .typeError('Debe ser un número')
        .required('Este campo es obligatorio'),
    codigo: yup.string().required('Este campo es obligatorio'),
    cupo: yup
        .number()
        .typeError('Debe ser un número')
        .required('Este campo es obligatorio'),
    fechaInicio: yup
        .date()
        .typeError('Debe ser una fecha válida (ej: 2025-08-22)')
        .required('La fecha de inicio es requerida'),
    fechaFinalizacion: yup
        .date()
        .typeError('Debe ser una fecha válida (ej: 2025-08-22)')
        .required('La fecha de finalización es requerida'),
    familiaIdFamilia: yup
        .number()
        .typeError('Seleccione una opción')
        .required('Este campo es obligatorio'),
    instructorIdInstructor: yup
        .number()
        .typeError('Seleccione una opción')
        .required('Este campo es obligatorio'),
    tipo_id_tipo: yup
        .number()
        .typeError('Seleccione una opción')
        .required('Este campo es obligatorio'),
    })

    return (

        <Container fluid className='border border-dark'>
            <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                if (onSubmit) {
                    onSubmit(values); // este viene de ActualizarCurso
                } else {
                    handleSubmit(values); // este es el default para CrearCurso
                }
            }}
            enableReinitialize= {true}
            >
                {({touched, errors}) => (     
                <Form >
                    <Row className='mt-4'>
                        <Col>
                            <label htmlFor='nombreCurso' className='form-label'>Curso{asterico}</label>
                            <Field
                                type="text"
                                placeholder="Ingresá el nombre del curso nuevo"
                                id="nombre"
                                name='nombre'

                                className={`form-control ${touched.nombre && errors.nombre ? 'is-invalid' : touched.nombre && !errors.nombre ? 'is-valid' : ''
                                }`}
                            />
                            <ErrorMessage
                                name="nombre"
                                component="div"
                                className="text-danger"
                            />
                        </Col>
                        <Col md={3}>
                            <label htmlFor='Número de Curso' className='form-label'>N° de Curso {asterico}</label>
                            <Field
                                type= 'text'
                                placeholder='Ej. 20'
                                id= 'nroCurso'
                                name= 'nroCurso'
                                className={`form-control ${touched.nroCurso && errors.nroCurso ? 'is-invalid' : touched.nroCurso && !errors.nroCurso ? 'is-valid' : ''}`}
                            />    
                            <ErrorMessage
                                name="nroCurso"
                                component="div"
                                className="text-danger"
                            />
                        </Col>
                        <Col md={3}>
                            <label htmlFor='Código  de Curso' className='form-label'>Código de Curso {asterico}</label>
                            <Field
                                type= 'text'
                                placeholder='Ej. GH-2023-43'
                                id= 'codigo'
                                name= 'codigo'
                                className={`form-control ${touched.codigo && errors.codigo ? 'is-invalid' : touched.codigo && !errors.codigo ? 'is-valid' : ''}`}
                            />    
                            <ErrorMessage
                                name="codigo"
                                component="div"
                                className="text-danger"
                            />
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md={5}>
                        <label htmlFor='Fecha de inicio' className='form-label'>Inicio del Curso{asterico}</label>
                                <Field
                                    type="text"
                                    placeholder="Ej. 2025-08-22 (formato: Año-Mes-Día)"
                                    id="fechaInicio"
                                    name='fechaInicio'
                                    className={`form-control ${touched.fechaInicio && errors.fechaInicio ? 'is-invalid' : touched.fechaInicio && !errors.fechaInicio ? 'is-valid' : ''
                                    }`}
                                />
                                <ErrorMessage
                                    name="fechaInicio"
                                    component="div"
                                    className="text-danger"
                                />
                        </Col>
                        <Col md={5}>
                        <label htmlFor='Fecha de finalizacion' className='form-label'>Finalización del Curso{asterico}</label>
                                <Field
                                    type="text"
                                    placeholder="Ej. 2025-08-22 (formato: Año-Mes-Día)"
                                    id="fechaFinalizacion"
                                    name='fechaFinalizacion'
                                    className={`form-control ${touched.fechaFinalizacion && errors.fechaFinalizacion ? 'is-invalid' : touched.fechaFinalizacion && !errors.fechaFinalizacion ? 'is-valid' : ''
                                     }`}
                                />
                                <ErrorMessage
                                    name="fechaFinalizacion"
                                    component="div"
                                    className="text-danger"
                                />
                        </Col>
                        <Col md={2}>
                        <label htmlFor='Cupo' className='form-label'>Cantidad de cupos{asterico}</label>
                                <Field
                                    type="text"
                                    placeholder="Ej. 35"
                                    id="cupo"
                                    name='cupo'
                                    className={`form-control ${touched.cupo && errors.cupo ? 'is-invalid' : touched.cupo && !errors.cupo ? 'is-valid' : ''
                                     }`}
                                />
                                <ErrorMessage
                                    name="cupo"
                                    component="div"
                                    className="text-danger"
                                />
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md={6}>
                            <label htmlFor='HorasCatedra' className='form-label'>Horas Cátedra{asterico}</label>
                                <Field
                                    type="text"
                                    placeholder="Ej. 200"
                                    id="horasCatedra"
                                    name='horasCatedra'
                                    className={`form-control ${touched.horasCatedra && errors.horasCatedra ? 'is-invalid' : touched.horasCatedra && !errors.horasCatedra ? 'is-valid' : ''
                                     }`}
                                />
                                <ErrorMessage
                                    name="horasCatedra"
                                    component="div"
                                    className="text-danger"
                                />
                        </Col>
                        <Col md={6}>
                            <label htmlFor='HorasReloj' className='form-label'>Horas Reloj{asterico}</label>
                                <Field
                                    type="text"
                                    placeholder="Ej. 150"
                                    id="horasReloj"
                                    name='horasReloj'
                                    className={`form-control ${touched.horasReloj && errors.horasReloj ? 'is-invalid' : touched.horasReloj && !errors.horasReloj ? 'is-valid' : ''
                                     }`}
                                />
                                <ErrorMessage
                                    name="horasReloj"
                                    component="div"
                                    className="text-danger"
                                />
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md={6}>
                            <label htmlFor='familiaIdFamilia' className='form-label'>Familia*</label>
                            <Field as="select" name="familiaIdFamilia" className="form-control">
                                <option value="">Seleccione una familia</option>
                                {Array.isArray(familias) &&
                                [...familias]
                                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                                    .map((fam) => (
                                    <option key={fam.idFamilia} value={fam.idFamilia}>
                                        {fam.nombre}
                                    </option>
                                    ))
                                }
                            </Field>
                            <ErrorMessage name="familiaIdFamilia" component="div" className="text-danger" />
                        </Col>
                        <Col md={6}>
                            <label htmlFor='instructorIdInstructor' className='form-label'>Instructor*</label>
                            <Field as="select" name="instructorIdInstructor" className="form-control">
                                <option value="">Seleccione una Instructor</option>
                               {Array.isArray(instructores) &&
                                [...instructores]
                                .sort((a, b) => {
                                    const apellidoA = a.apellido.toLowerCase();
                                    const apellidoB = b.apellido.toLowerCase();
                                    if (apellidoA < apellidoB) return -1;
                                    if (apellidoA > apellidoB) return 1;
                                    return a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase());
                                })
                                .map((inst) => (
                                    <option key={inst.idInstructor} value={inst.idInstructor}>
                                    {`${inst.apellido}, ${inst.nombre}`}
                                    </option>
                                ))}
                            </Field>
                            <ErrorMessage name="instructorIdInstructor" component="div" className="text-danger" />
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                            <label htmlFor='tipo_id_tipo' className='form-label'>Familia*</label>
                            <Field as="select" name="tipo_id_tipo" className="form-control">
                                <option value="">Seleccione una familia</option>
                                {Array.isArray(tipos) &&
                                [...tipos]
                                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                                    .map((tipo) => (
                                    <option key={tipo.idTipo} value={tipo.idTipo}>
                                        {tipo.nombre}
                                    </option>
                                    ))
                                }
                            </Field>
                            <ErrorMessage name="tipo_id_tipo" component="div" className="text-danger" />
                        </Col>
                    </Row>

                    <Row className='mt-3 mb-3'>
                        <Col className='text-center'>
                            <Button variant='success' type='submit' disabled={loading}>
                                {loading ? "Cargando..." : isEditing ? "Actualizar" : "Crear"}
                            </Button>

                        </Col>
                    </Row>
                </Form>
                )}
            </Formik>
        </Container>
    )
}

export default FormCursoDos;